import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getEventsCandidature(idCandidature) {
    const response = await axios.get(
      "/api/candidature/" + idCandidature + "/events"
    );
    return response.data;
  },
};
